module.exports = __webpack_public_path__ + "img/signing-white.86c63a43.png";